import React from 'react'
import { MdClear } from 'react-icons/md'
import cn from 'classnames'

import 'components/graph/controls/controls.less'
import 'components/graph/controls/deselectAll.less'

type DeselectAllControlProps = {
  deselectAll: () => void
  isCreating: boolean
  isEditing: boolean
  control: string
}

const DeselectAllControl = ({ deselectAll, isCreating, isEditing, control }: DeselectAllControlProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    if (isCreating || isEditing) {
      return
    }
    deselectAll()
  }

  return (
    <div className={cn('control', 'deselect-all')} data-graph-type="control" title={`Deselect All ${control}`}>
      <a className={cn('icon', { disabled: isCreating || isEditing })} onClick={handleClick}>
        <MdClear aria-hidden />
        <span className="sr-only">Deselect All</span>
      </a>
    </div>
  )
}

export default DeselectAllControl
